<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">


  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px padding-bottom-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Oocyte Quality
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">
                      <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}} years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>
                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                    <!--<div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient()">
                      <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient()">
                        <img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">



                      </div>
                      <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="margin-bottom-0px">Ramya santhosh</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">32 years,GGHOI/027</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">9899989891</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>-->
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-9 " *ngIf="ScanDetails">

          <div class="row" *ngIf="SelectedpatientDetails">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 ">
                      <div class="row row-height-17px margin-left-0px">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}} </label>
                        </div>
                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->
                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-2">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>

                    </div>
                    <div class="col-md-7  padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="OocyteData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{OocyteData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-9 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-2 padding-right-0px padding-left-10px" *ngIf="OocyteData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{OocyteData2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px" hidden>
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3 margin-right-5pe" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                  <div class="card margin-right-54px">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px bk-color-light">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Oocyte Quality Assessment
                          </label>
                        </div>
                        <div class="col-md-6  padding-left-0px ">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row float-right">
                            <div class="col-md-9  padding-left-0px" *ngIf="OocyteData2">
                              <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal display-edit" (click)="Assessment()" title="Assessment Completed" *ngIf="OocyteData2.ActivityStatus !=='Completed'"> Assessment Completed</a>
                            </div>
                            <div class="col-md-1 padding-left-0px" *ngIf="OocyteData2">
                              <button type="button"
                                      (click)="AddRow()"
                                      class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                      name="upload " title="Click Here To Add New Row" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                                <i class="fas fa-plus font-size-11"></i>
                              </button>
                            </div>
                            <div class="col-md-1" *ngIf="OocyteData2">
                              <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printoocyte()" *ngIf="OocyteData2.ActivityStatus =='Completed'">
                                <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                              </a>
                            </div>
                          </div>




                        </div>

                      </div>
                    </div>
                    <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps overflow-x-hidden padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body padding-right-0px padding-left-0px padding-top-0px">
                        <!--<form class="form " novalidate="" #f="ngForm">-->
                        <div class="table-component">
                          <div class="table-responsive">


                            <table class="table table-striped margin-left-zero width-50-new">
                              <thead class="">
                                <tr>

                                  <th class="min-width-0px">
                                    S.No
                                  </th>


                                  <th class="td-well-width-79px">
                                    Well #
                                  </th>

                                  <th>OCC</th>
                                  <th>Denuded</th>
                                  <th>
                                    Morphology
                                  </th>

                                  <th class="">
                                    Freeze
                                  </th>





                                  <th class="">Discard</th>

                                  <th></th>



                                </tr>
                              </thead>

                              <tbody class="table-body" *ngIf="CurrentOocyteQualityAssessmentByCodeController">
                                <tr *ngFor="let l of CurrentOocyteQualityAssessmentByCodeController;let i = index">

                                  <td class="padding-all-0px text-align-center width-th-52px">
                                    {{i+1}}

                                  </td>

                                  <td class="padding-all-0px">

                                    <input type="text" class="form-control" placeholder=""
                                           [(ngModel)]="l.WellNo"
                                           maxlength="2" required>

                                    <!--<small class="form-text text-danger"
                                           *ngIf="(!Well.valid && (Well.dirty || Well.touched) && Well.errors.required )">(Field cannot be left blank)</small>
                                    <small class="form-text text-danger"
                                           *ngIf="(!Well.valid && Well.errors.pattern)">(special characters are not allowed)</small>-->
                                  </td>
                                  <td class="padding-all-0px">
                                    <!--<CodeTypeValue CodeType="IVFOQ"></CodeTypeValue>-->

                                    <CodeTypeValue CodeType="IVFOQ"
                                                   [(ngModel)]="l.OocyteQualityPre" SelectedValue="l.OocyteQualityPre"
                                                   required>
                                    </CodeTypeValue>
                                  </td>
                                  <td class="padding-all-0px">
                                    <CodeTypeValue CodeType="IVFOQ"
                                                   id="l.OocyteQualityPost"
                                                   [(ngModel)]="l.OocyteQualityPost" SelectedValue="l.OocyteQualityPost"
                                                   name="l.OocyteQualityPost" required>
                                    </CodeTypeValue>
                                  </td>
                                  <td class="padding-all-0px">
                                    <CodeTypeValue CodeType="IVFMR"
                                                   id="l.Morphology"
                                                   [(ngModel)]="l.Morphology" SelectedValue="l.Morphology"
                                                   name="l.Morphology" required>
                                    </CodeTypeValue>
                                    <!--<CodeTypeValue CodeType="IVFMR"></CodeTypeValue>-->

                                  </td>
                                  <td class="padding-all-0px text-align-center"><input type="checkbox" [(ngModel)]="l.IsFrozen" name="l.IsFrozen"></td>
                                  <td class="padding-all-0px text-align-center"><input type="checkbox" [(ngModel)]="l.IsDiscarded" name="l.IsDiscarded"></td>
                                  <td class="padding-all-0px">
                                    <div class="test-icons" *ngIf="OocyteData2">


                                      <button (click)="onSubmit (l)"
                                              class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save" [disabled]="clicked" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                                        <i class="far fa-save"></i>
                                      </button>
                                      <a (click)="delwell(l)" class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="l.SingleWellFollicleCoder>0 && OocyteData2.ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                    </div>
                                  </td>
                                </tr>
                                <!--<tr>

                                  <td>2</td>
                                  <td><input type="number" class="form-control"></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="MORPH"></CodeTypeValue></td>
                                  <td><input type="checkbox" /></td>
                                  <td><input type="checkbox" /></td>
                                  <td> <button type="submit" class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></button></td>
                                </tr>
                                <tr>

                                  <td>3</td>
                                  <td><input type="number" class="form-control"></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="MORPH"></CodeTypeValue></td>
                                  <td><input type="checkbox" /></td>
                                  <td><input type="checkbox" /></td>
                                  <td> <button type="submit" class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></button></td>
                                </tr>
                                <tr>

                                  <td>4</td>
                                  <td><input type="number" class="form-control"></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="OQATY"></CodeTypeValue></td>
                                  <td><CodeTypeValue CodeType="MORPH"></CodeTypeValue></td>
                                  <td><input type="checkbox" /></td>
                                  <td><input type="checkbox" /></td>
                                  <td> <button type="submit" class="button-service-save font-size-20px color-secondary nav-link-hand" title="Save"><i class="far fa-save"></i></button></td>
                                </tr>-->
                              </tbody>

                            </table>

                          </div>
                        </div>

                        <!--</form>-->
                        <!--<div class="accordion margin-bottom-20px" id="accordionExample5">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                      Oocyte Quality Assessment
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8 ">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                </div>

                              </div>


                            </div>

                            <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                <div class="card margin-bottom-0px">

                                  <div class="card-body padding-top-0px padding-bottom-0px">
                                    <div class="table-component">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero width-50-new">
                                          <thead class="">
                                            <tr>

                                              <th>
                                                S.No
                                              </th>


                                              <th class="">
                                                Well#
                                              </th>
                                              <th>Pre wash</th>
                                              <th >Post Wash</th>
                                              <th >
                                                Morphology
                                              </th>

                                              <th class="">
                                                Freeze
                                              </th>





                                              <th class="">Discard</th>

                                              <th></th>



                                            </tr>
                                          </thead>

                                          <tbody class="table-body">
                                            <tr>

                                              <td>1</td>
                                              <td><input type="number" class="form-control"></td>
                                              <td><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>
                                              <td><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>
                                              <td><CodeTypeValue CodeType="FNSTS"></CodeTypeValue></td>
                                              <td><input type="checkbox" /></td>
                                              <td><input type="checkbox" /></td>
                                              <td> <button type="submit"  class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" ><i class="far fa-save"></i></button></td>
                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>-->
                        <div class="accordion" id="accordionExample2">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                      Oocyte Storage
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                </div>
                                <!--<div class="col-md-6">
                                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                </div>-->
                              </div>


                            </div>

                            <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="row" *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0">
                                      <button (click)="Store()" class="btn font-size-13px actions-btn-prime margin-left-auto margin-right-auto">Init Store</button>
                                    </div>
                                    <div class="row" *ngIf="CurrentIvfOocyteEmbryoStorageByCodeController ==null || CurrentIvfOocyteEmbryoStorageByCodeController.length == 0">
                                      <div class="col-md-6 margin-left-auto margin-right-auto">
                                        <label class="color-Rejected  font-size-11px">(This operation cannot be repeated once storage is initiated and saved )</label>
                                      </div>



                                    </div>
                                    <div class="row">
                                      <div class="col-md-12 ">
                                        <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Well Culture'">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                                  <th class="padding-top-4px padding-bottom-4px">Well#</th>

                                                  <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                                  <th class="padding-top-4px padding-bottom-4px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="OocyteData2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">
                                                <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                                <!--</ng-container>-->
                                                <tr *ngFor="let l of OocyteStoreItems">
                                                  <td class="td-padding padding-all-0px ">

                                                    <input type="checkbox" name="l.IsSelected"
                                                           [(ngModel)]="l.IsSelected">
                                                    <i class="input-helper"></i>

                                                  </td>


                                                  <td class="text-align-center padding-all-0px">{{l.WellNo}}</td>

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                                  <td class="padding-all-0px">

                                                    <CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                                                   required></CodeTypeValue>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                           id="l.StorageUnitDetails"
                                                           [(ngModel)]="l.StorageUnitDetails"
                                                           name="l.StorageUnitDetails" #Remarks="ngModel"
                                                           maxlength="100">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                      <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                      </i>
                                                    </a>
                                                  </td>
                                                  <td class="padding-all-0px" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                                                    <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>
                                        <div class="table-component" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                                          <div class="table-responsive">


                                            <table class="table table-striped margin-left-zero">

                                              <thead class="">
                                                <tr>
                                                  <th class="min-width-0px padding-top-4px padding-bottom-4px"></th>


                                                  <th class="padding-top-4px padding-bottom-4px">GroupId</th>

                                                  <th class="padding-top-4px padding-bottom-4px">Morphology</th>
                                                  <th class="white-space-preline padding-top-4px padding-bottom-4px">Storage</th>
                                                  <th class="padding-top-4px padding-bottom-4px">Details</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-right-0px">Status</th>
                                                  <th class="padding-top-4px padding-bottom-4px padding-left-0px padding-right-0px" *ngIf="OocyteData2.ActivityStatus !=='Completed'"></th>
                                                </tr>
                                              </thead>
                                              <tbody class="table-body">
                                                <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                                <!--</ng-container>-->
                                                <tr *ngFor="let l of OocyteStoreItems">
                                                  <td class="td-padding padding-all-0px ">

                                                    <input type="checkbox" name="l.IsSelected"
                                                           [(ngModel)]="l.IsSelected">
                                                    <i class="input-helper"></i>

                                                  </td>


                                                  <td class="text-align-center padding-all-0px"></td>

                                                  <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                                  <td class="padding-all-0px">

                                                    <CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                                                                   required></CodeTypeValue>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px">
                                                    <input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                                           id="l.StorageUnitDetails"
                                                           [(ngModel)]="l.StorageUnitDetails"
                                                           name="l.StorageUnitDetails" #Remarks="ngModel"
                                                           maxlength="100">
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                    <small class="form-text text-danger"
                                                           *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                                  </td>
                                                  <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                                                    <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                      <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                      </i>
                                                    </a>
                                                  </td>
                                                  <td class="padding-all-0px" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                                                    <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                                                  </td>



                                                </tr>
                                              </tbody>

                                            </table>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                <div class="card margin-bottom-0px background-lightpink">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                    <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                                      <div class="table-responsive">


                                        <table class="table table-striped margin-left-zero">

                                          <thead class="">
                                            <tr>
                                              <th class=" td-width-107px">Ov.Position</th>
                                              <th class="padding-left-5px width-70px">Count</th>
                                              <th class="padding-left-5px width-70px">Size</th>
                                              <th>Comments</th>

                                            </tr>
                                          </thead>
                                          <tbody class="table-body">

                                            <tr>

                                              <td>
                                                <CodeTypeValue CodeType="OVPS"
                                                               id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                                               [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                                               name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                                                </CodeTypeValue>
                                              </td>

                                              <td class="td-padding ">

                                                <input type="number" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                                              </td>
                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                                              </td>

                                              <td class="td-padding ">
                                                <input type="text" class="form-control"
                                                       min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                                       name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                                       maxlength="100">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                                              </td>



                                            </tr>

                                          </tbody>

                                        </table>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>-->
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="card-body padding-right-0px padding-top-0px" *ngIf="SelectedpatientDetails.GradingModel=='Droplet Culture'">
                  <div class="card margin-right-54px">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px bk-color-light">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-5 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Oocyte Quality Assessment
                          </label>
                        </div>
                        <div class="col-md-6  padding-left-0px ">
                          <div class="row">
                            <div class="col-md-10  padding-left-0px padding-right-0px" *ngIf="OocyteData2">
                              <a class="nav-link-hand float-right patientreg-link padding-top-5px font-weight-normal display-edit" (click)="Assessment()" title="Assessment Completed" *ngIf="OocyteData2.ActivityStatus !=='Completed'"> Assessment Completed</a>
                            </div>
                            <!--<div class="col-md-1 padding-left-0px">
        <button type="button"

                class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                name="upload " title="Click Here To Add New Row">
          <i class="fas fa-plus font-size-11"></i>
        </button>
      </div>-->

                          </div>
                        </div>
                        <div class="col-md-1" *ngIf="OocyteData2">
                          <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printoocytedroplet()">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>
                          <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printoocytedroplet()" *ngIf="OocyteData2.ActivityStatus =='Completed'">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>-->
                        </div>
                      </div>
                    </div>
                    <div class="" data-ps-id="dfsfsde">
                      <div class="card-body padding-right-0px padding-left-0px padding-top-0px">
                        <div *ngIf="DenudationInfo && OocyteData2">
                          <!--<form class="form " novalidate="" #f="ngForm">-->
                          <form class="form " novalidate="" (ngSubmit)="onSubmit3()" #f="ngForm">
                            <div class="accordion margin-top-5px" id="accordionExampleoqa4" *ngIf="OocyteData2.ActivityStatus !=='Completed'">

                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingoqa4">
                                  <div class="row">
                                    <div class="col-md-3">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseoqa4" aria-expanded="true" aria-controls="collapseoqa4">
                                          Denudation
                                        </button>
                                      </h5>
                                    </div>
                                    <!--<div class="col-md-1">
                                      <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>

                                    </div>-->
                                    <!--<div class="col-md-1 padding-left-0px">
                                      <button type="button" (click)="AddOqa()"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                              name="upload " title="Click Here To Add New Row">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                    </div>-->
                                    <div class="col-md-3">
                                      <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseoqa4" class="collapse show" aria-labelledby="headingoqa4" data-parent="#accordionExampleoqa4">
                                  <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                    <div class="card margin-bottom-0px margin-top-10">

                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                        <div class="row margin-left-0px">
                                          <div class="col-md-2 padding-right-0px">
                                            <label class="margin-bottom-0px">
                                              Denudation By
                                            </label>
                                          </div>:
                                          <div class="col-md-3 padding-right-0px">
                                            <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                                     id="DenudationInfo.DenudedByActor" SelectedValue="DenudationInfo.DenudedByActor"
                                                                     [(ngModel)]="DenudationInfo.DenudedByActor" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                     name="DenudationInfo.DenudedByActor" required #DenudationBy="ngModel">
                                            </CustomDataByRequestType>
                                            <!--<label class="margin-bottom-0px" *ngIf="Displaynew">{{ProvidedName2}}</label>
                                            <label class="margin-bottom-0px" *ngIf="Displayold">{{CurrentSaveOocyteMaturityInfoRequest.ProvidedName2}}</label>-->
                                          </div>
                                          <!--<div class="col-md-1 padding-left-0px">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="ProvidedSelection2()"> <i class="fas fa-ellipsis-h"></i></button>
                                          </div>-->
                                        </div>

                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>


                            </div>

                          </form>
                        </div>

                        <div *ngIf="DenudationInfo && OocyteData2">
                          <!--<form class="form " novalidate="" #f="ngForm">-->
                          <form class="form " novalidate="" (ngSubmit)="onSubmit3()" #f="ngForm">
                            <div class="accordion margin-top-5px" id="accordionExampleoqa4" *ngIf="OocyteData2.ActivityStatus =='Completed'">

                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingoqa4">
                                  <div class="row">
                                    <div class="col-md-3">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseoqa4" aria-expanded="true" aria-controls="collapseoqa4">
                                          Denudation
                                        </button>
                                      </h5>
                                    </div>

                                    <div class="col-md-3">
                                      <!--<button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseoqa4" class="collapse show" aria-labelledby="headingoqa4" data-parent="#accordionExampleoqa4">
                                  <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                    <div class="card margin-bottom-0px margin-top-10">

                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                        <div class="row margin-left-0px">
                                          <div class="col-md-2 padding-right-0px">
                                            <label class="margin-bottom-0px">
                                              Denudation By
                                            </label>
                                          </div>:
                                          <div class="col-md-3 padding-right-0px">
                                            <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                                     id="DenudationInfo.DenudedByActor" SelectedValue="DenudationInfo.DenudedByActor"
                                                                     [(ngModel)]="DenudationInfo.DenudedByActor" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                     name="DenudationInfo.DenudedByActor" required #DenudationBy="ngModel">
                                            </CustomDataByRequestType>-->

                                            <label class="margin-bottom-0px ">{{DenudationInfo.DenudationBy}}</label>

                                          </div>

                                        </div>

                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>


                            </div>

                          </form>
                        </div>

                        <div *ngIf="DenudationInfo">
                          <div class="accordion margin-top-5px" id="accordionExampleoqa3">

                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingoqa3">
                                <div class="row">
                                  <div class="col-md-3">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseoqa3" aria-expanded="true" aria-controls="collapseoqa3">
                                        OQA
                                      </button>
                                    </h5>
                                  </div>
                                  <div class="col-md-3" *ngIf="OocyteData2">
                                    <button (click)="OnSubmitOqanew()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="OocyteData2.ActivityStatus !=='Completed'">Save<i class="far fa-save nav-link-hand font-size-14 margin-left-3px"></i></button>
                                  </div>
                                  <!--<div class="col-md-1 padding-left-0px">
                                    <button type="button" (click)="AddOqa()"
                                            class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                                            name="upload " title="Click Here To Add New Row">
                                      <i class="fas fa-plus font-size-11"></i>
                                    </button>
                                  </div>-->

                                </div>


                              </div>

                              <div id="collapseoqa3" class="collapse show" aria-labelledby="headingoqa3" data-parent="#accordionExampleoqa3">
                                <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                  <div class="card margin-bottom-0px margin-top-10">

                                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                      <div class="row">
                                        <div class="col-md-6 padding-right-0px">
                                          <div class="table-component">
                                            <div class="table-responsive">


                                              <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                                                <thead class="">
                                                  <tr>
                                                    <th class="padding-top-4px padding-bottom-4px td-width-10px"></th>
                                                    <th class="td-oqaa-width padding-top-4px padding-bottom-4px"></th>
                                                    <!--<th class="td-well-width-79px padding-top-4px padding-bottom-4px"></th>-->
                                                    <!--<th class="padding-top-4px padding-bottom-4px"></th>-->
                                                  </tr>
                                                </thead>

                                                <tbody class="table-body">
                                                  <tr *ngFor="let l of CurrentOocyteMaturityByCycleController">


                                                    <td class="padding-top-4px padding-bottom-4px ">

                                                      <!--<CodeTypeValue CodeType="OCTML"
                                                      [(ngModel)]="l.MaturityLevel" SelectedValue="l.MaturityLevel"
                                                      required></CodeTypeValue>-->
                                                      <label class="margin-bottom-0px">{{l.MaturityLevel}}</label>
                                                    </td>
                                                    <td class="padding-top-4px padding-bottom-4px">
                                                      <!--<input type="text" class="form-control " placeholder="" [(ngModel)]="l.OccCount"
                                                      maxlength="2" required>-->
                                                      <div *ngIf="OocyteData2">
                                                        <!--<input type="text" class="form-control " placeholder="" [(ngModel)]="l.OccCount" required
                                                               maxlength="2" *ngIf="OocyteData2.ActivityStatus !=='Completed'">-->
                                                        <CodeTypeValue CodeType="1to50" id="l.OccCount"
                                                                       [(ngModel)]="l.OccCount" SelectedValue="l.OccCount"
                                                                       name="l.OccCount" required #DataNew="ngModel" *ngIf="OocyteData2.ActivityStatus !=='Completed'">

                                                        </CodeTypeValue>


                                                        <!--<button class="btn actions-btn-ooctyte margin-bottom-0px font-size-18px" (click)="EditOqa(l)" *ngIf="OocyteData2.ActivityStatus !=='Completed'" title="Click Here to Edit">{{l.OccCount}}</button-->
                                                        <label class="margin-bottom-0px font-size-18px" *ngIf="OocyteData2.ActivityStatus =='Completed'">{{l.OccCount}}</label>

                                                      </div>
                                                      <!--<div *ngIf="OocyteData2.ActivityStatus =='Completed'">
                                                        <label class="margin-bottom-0px font-size-18px" (click)="E>{{l.OccCount}}</label>
                                                      </div>-->


                                                    </td>
                                                    <!--<td class="padding-all-0px">
                                                      <input type="text" class="form-control text-align-right" placeholder="" [(ngModel)]="l.DenudedCount"
                                                             maxlength="2" required>
                                                    </td>-->
                                                    <!--<td class="padding-all-0px">
                                                      <div *ngIf="OocyteData2">
                                                        <div class="test-icons margin-top-7px" *ngIf="OocyteData2.ActivityStatus !=='Completed'">


                                                          <a class="font-size-16px color-Assign" (click)="EditOqa(l)" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                                          <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                        </div>
                                                      </div>
                                                    </td>-->
                                                  </tr>

                                                </tbody>

                                              </table>

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>


                          </div>
                        </div>

                        <div *ngIf="DenudationInfo">
                          <div class="accordion" id="accordionExample2">

                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                <div class="row">
                                  <div class="col-md-2">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                        Oocyte Abnormalities
                                      </button>
                                    </h5>
                                  </div>
                                  <div class="col-md-3">
                                    <!--<button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>-->
                                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange2($event)"></search-list>
                                  </div>
                                  <div class="col-md-1 padding-left-0px" *ngIf="OocyteData2">
                                    <!--<button type="button" (click)="AddAbnormalOqa()"
                                            class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" *ngIf="OocyteData2.ActivityStatus !=='Completed'"
                                            name="upload " title="Click Here To Add New Row">
                                      <i class="fas fa-plus font-size-11"></i>
                                    </button>-->
                                    <button (click)="OnSubmitOqaanormailites()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="OocyteData2.ActivityStatus !=='Completed'">Save<i class="far fa-save nav-link-hand font-size-14 margin-left-3px"></i></button>

                                  </div>

                                </div>


                              </div>

                              <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                  <div class="card margin-bottom-0px margin-top-10">

                                    <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                      <div class="row">
                                        <div class="col-md-6 padding-right-0px ">
                                          <div class="table-component">
                                            <div class="table-responsive">


                                              <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                                                <thead class="">
                                                  <tr>
                                                    <th class="padding-top-4px padding-bottom-4px  min-width-0px"></th>
                                                    <!--<th class="padding-top-4px padding-bottom-4px"></th>-->
                                                    <th class="padding-top-4px padding-bottom-4px"></th>
                                                    <th class="td-oqaa-width padding-top-4px padding-bottom-4px"></th>
                                                    <!--<th class="padding-top-4px padding-bottom-4px"></th>-->

                                                  </tr>
                                                </thead>

                                                <tbody class="table-body">
                                                  <tr *ngFor="let l of pdata2 ; let RowIndex = index ">
                                                    <td class="padding-top-4px padding-bottom-4px td-width-10px">{{RowIndex+1}}</td>

                                                    <td class="padding-top-4px padding-bottom-4px">
                                                      <!--<CodeTypeValue CodeType="IVFMR"
                                                      [(ngModel)]="l.Morphology" SelectedValue="l.Morphology"
                                                      required></CodeTypeValue>-->
                                                      <label class="margin-bottom-0px">{{l.Morphology}}</label>
                                                      <!--<CodeTypeValue CodeType="IVFMR"></CodeTypeValue>-->

                                                    </td>
                                                    <td class="padding-top-4px padding-bottom-4px">
                                                      <!--<input type="text" class="form-control text-align-right" placeholder="" [(ngModel)]="l.OocyteCount"
                                                      maxlength="2" required>-->
                                                      <div *ngIf="OocyteData2">
                                                        <!--<button class="btn actions-btn-ooctyte margin-bottom-0px font-size-18px" (click)="EditAbnormalOqa(l)" *ngIf="OocyteData2.ActivityStatus !=='Completed'" title="Click Here to Edit">{{l.OocyteCount}}</button>-->
                                                        <CodeTypeValue CodeType="1to20" id="l.OocyteCount"
                                                                       [(ngModel)]="l.OocyteCount" SelectedValue="l.OocyteCount"
                                                                       name="l.OocyteCount" required #DataNew2="ngModel" *ngIf="OocyteData2.ActivityStatus !=='Completed'">

                                                        </CodeTypeValue>
                                                        <label class="margin-bottom-0px font-size-18px" *ngIf="OocyteData2.ActivityStatus =='Completed'">{{l.OocyteCount}}</label>
                                                      </div>

                                                    </td>
                                                    <!--<td class="padding-top-0px padding-bottom-0px">
                                                      <div class="test-icons margin-top-7px" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                                                        <a (click)="EditAbnormalOqa(l)" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>

                                                      </div>
                                                    </td>-->
                                                  </tr>

                                                </tbody>

                                              </table>

                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>







      </div>
    </div>

  </div>
  <div class="row" *ngIf="Showivf">
    <div class="col-md-12">
      <ivfworkbench></ivfworkbench>
    </div>
  </div>
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
